/* tslint:disable */
import {
  Sector
} from '../index';

declare var Object: any;
export interface PopulationCategoryInterface {
  "name": string;
  "description"?: string;
  "sort_order"?: number;
  "id"?: number;
  "sector_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  sector?: Sector;
}

export class PopulationCategory implements PopulationCategoryInterface {
  "name": string;
  "description": string;
  "sort_order": number;
  "id": number;
  "sector_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  sector: Sector;
  constructor(data?: PopulationCategoryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PopulationCategory`.
   */
  public static getModelName() {
    return "PopulationCategory";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PopulationCategory for dynamic purposes.
  **/
  public static factory(data: PopulationCategoryInterface): PopulationCategory{
    return new PopulationCategory(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PopulationCategory',
      plural: 'PopulationCategories',
      path: 'PopulationCategories',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "sort_order": {
          name: 'sort_order',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "sector_id": {
          name: 'sector_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        sector: {
          name: 'sector',
          type: 'Sector',
          model: 'Sector'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/PopulationCategory.ts